export function inputValueAsString(
  value: React.InputHTMLAttributes<HTMLInputElement>['value'],
): string {
  return value ? (Array.isArray(value) ? value.join(',') : String(value)) : ''
}
